import { render } from "./ReportsFilter.vue?vue&type=template&id=24cf4baa"
import script from "./ReportsFilter.vue?vue&type=script&lang=js"
export * from "./ReportsFilter.vue?vue&type=script&lang=js"

import "./ReportsFilter.vue?vue&type=style&index=0&id=24cf4baa&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__